"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "castel-san-giovanni": {
    "6fc9c915": [{
      "hkey": "1a34cf51",
      "slug": "creta-bruciate",
      "name": "Creta-Bruciate",
      "primary": true,
      "skipSearch": false
    }],
    "creta": [{
      "hkey": "1a34cf51",
      "slug": "creta-bruciate",
      "name": "Creta-Bruciate",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "680f7c97": [{
      "hkey": "7b2c6bc9",
      "slug": "castel-san-giovanni",
      "name": "Castel San Giovanni",
      "primary": true,
      "skipSearch": false
    }],
    "parpanese": [{
      "hkey": "7b2c6bc9",
      "slug": "castel-san-giovanni",
      "name": "Castel San Giovanni",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "fee73b86": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "skipSearch": false
    }],
    "bosco-tosca": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5690e298": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "skipSearch": false
    }],
    "dogana": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "1f6e6751": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "skipSearch": false
    }],
    "pievetta": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5b25bae2": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "skipSearch": false
    }],
    "pievetta-dogana-po": [{
      "hkey": "4e78093b",
      "slug": "bosco-tosca-pievetta-dogana-po",
      "name": "Bosco Tosca-Pievetta-Dogana Po",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;